//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionText } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'
import { mapGetters } from 'vuex'

import { SpecialMenu } from '@navigation/components/SpecialMenu'
import { ROUTES } from '@router'

const MENU = {
  admin: {
    type: 'admin',
    bo: '/bo_merchant/admin_tools/dashboard',
    admin: true,
  },
  client: {
    type: 'client',
    bo: '/bo_merchant/admin_tools/clients/?cid=s',
    admin: false,
  },
  merchant: {
    type: 'merchant',
    bo: '/bo_merchant/admin_tools/merchants/?mid=s',
    admin: false,
  },
}

export default {
  components: {
    ActionText,
    SpecialMenu,
  },
  computed: {
    ROUTES: () => ROUTES,
    ...mapGetters({
      isStaff: 'user/isStaff',
      isShadowingClient: 'user/isShadowingClient',
      isShadowingMerchant: 'user/isShadowingMerchant',
    }),
    menu() {
      if (this.isStaff) {
        return MENU.admin
      }

      if (this.isShadowingClient) {
        return MENU.client
      }

      if (this.isShadowingMerchant) {
        return MENU.merchant
      }

      return null
    },
    hasMenu() {
      return !isEmpty(this.menu)
    },
  },
}
